import { createFileRoute } from "@tanstack/react-router";

import MainLayout from "/src/layouts/MainLayout";

export const Route = createFileRoute("/_main")({
  component: MainLayout,
});
